<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <worker-check-out-page /><br><br><br>
    </div>
  </div>
</template>

  <script>
  import WorkerCheckOutPage from '../../../Components/Worker/WorkerCheckOutPage.vue';
    export default {
      name: 'WorkerCheckOut',
      components: {
        'worker-check-out-page': WorkerCheckOutPage,
      },
    };
  </script>

  <style scoped>

  </style>
